import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <Layout title="Page introuvable">
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', minHeight: '60vh', textAlign: 'center',
                padding: '40px',
            }}>
                {/* Animated 404 */}
                <div style={{
                    fontSize: '96px', fontWeight: '900',
                    background: 'linear-gradient(135deg, var(--primary-700), var(--gold-400))',
                    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                    lineHeight: 1, marginBottom: '16px', letterSpacing: '-4px',
                    userSelect: 'none',
                }}>
                    404
                </div>
                <div style={{ fontSize: '28px', marginBottom: '8px' }}>🚗💨</div>
                <h2 style={{ fontSize: '20px', fontWeight: '800', color: 'var(--text-primary)', marginBottom: '10px' }}>
                    Page introuvable
                </h2>
                <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '30px', maxWidth: '380px', lineHeight: '1.6' }}>
                    La page que vous cherchez n'existe pas ou a été déplacée.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button className="btn btn-ghost" onClick={() => navigate(-1)} style={{ gap: '8px' }}>
                        <ArrowLeft size={16} /> Retour
                    </button>
                    <button className="btn btn-primary" onClick={() => navigate('/')} style={{ gap: '8px' }}>
                        <Home size={16} /> Accueil
                    </button>
                </div>
            </div>
        </Layout>
    );
};

export default NotFoundPage;
